import { Datagrid, List, TextField } from 'react-admin';

export const list = () => (
    <List>
        <Datagrid>
            <TextField source="name" />
            <TextField source="service" />
        </Datagrid>
    </List>
);

export default list;